import { render } from "./DefSlider.vue?vue&type=template&id=2aaaa8fa&scoped=true"
import script from "./DefSlider.vue?vue&type=script&lang=js"
export * from "./DefSlider.vue?vue&type=script&lang=js"

import "./DefSlider.vue?vue&type=style&index=0&id=2aaaa8fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aaaa8fa"]])

export default __exports__